import { type RoleId } from '../../role'
import { type DefaultRole } from '../types'

export const DEFAULT_USER_ID: RoleId = 'Role.user'

export const DEFAULT_USER: DefaultRole = {
  roleId: DEFAULT_USER_ID,
  name: 'User',
  permissionOverrides: [
    { permissionType: 'accountStatus:list', scope: 'company' }, // show account states for my company
    { permissionType: 'account:list', scope: 'self' }, // list accounts for my self
    { permissionType: 'area:list', scope: 'self' }, // TODO - most companies want reps to see other reps areas, do we want this to be the default?
    { permissionType: 'attachment:list', scope: 'company' }, // view attachments within company
    { permissionType: 'attachment:manage', scope: 'self' }, // for my own attachments
    { permissionType: 'userCard:save', scope: 'self' }, // edit my own MyCard
    { permissionType: 'availability:update', scope: 'self' },
    { permissionType: 'company:read', scope: 'company' }, // view my own company name and other settings
    { permissionType: 'contact:list', scope: 'downline' }, // list contacts for my downline TODO - this shouldn't be a default but added for certain teams
    { permissionType: 'contact:list', scope: 'self' }, // list contacts for my self
    { permissionType: 'contact:add', scope: 'self' }, // add contacts for my self
    { permissionType: 'contact:delete', scope: 'self' }, // delete contacts for my self
    { permissionType: 'conversation:list', scope: 'self' }, // list conversations for my self
    { permissionType: 'conversation:manage', scope: 'self' }, // manage conversations for my self
    { permissionType: 'disposition:save', scope: 'self' }, // save dispositions for my self
    { permissionType: 'evaluation:add', scope: 'self' }, // add evaluation for my self
    { permissionType: 'evaluation:list', scope: 'self' }, // get evaluation for my self
    { permissionType: 'evaluation:delete', scope: 'self' }, // delete evaluation for my self
    { permissionType: 'event:read', scope: 'self' }, // read calendar events for my self
    { permissionType: 'event:save', scope: 'self' }, // save calendar events for my self
    { permissionType: 'event:delete', scope: 'self' }, // delete calendar events for my self
    { permissionType: 'event:outcome:list', scope: 'company' }, // list event outcomes for my company
    { permissionType: 'externalLink:list', scope: 'downline' }, // list external links for my downline
    { permissionType: 'location:add', scope: 'company' }, // add custom property locations for my company
    { permissionType: 'tag:manage', scope: 'self' }, // add tags to my own accounts
    { permissionType: 'message:send', scope: 'company' }, // send messages to other users in my company
    { permissionType: 'message:send', scope: 'downline' }, // send messages to my downline
    { permissionType: 'message:delete', scope: 'self' }, // delete messages for myself
    { permissionType: 'plan:list', scope: 'self' }, // list plans for myself
    { permissionType: 'plan:add', scope: 'self' }, // add plans for myself
    { permissionType: 'program:list', scope: 'company' },
    { permissionType: 'reportConfig:manage', scope: 'self' }, // manage report configs for myself
    { permissionType: 'ratio:list', scope: 'company' }, // list roles for company
    { permissionType: 'role:list', scope: 'company' }, // list roles for my company
    { permissionType: 'rubric:list', scope: 'company' }, // list roles for my company
    { permissionType: 'task:update', scope: 'self' }, // update my own tasks
    { permissionType: 'task:list', scope: 'self' }, // list tasks for myself
    { permissionType: 'team:list', scope: 'company' }, // list teams for my company
    { permissionType: 'user:list', scope: 'company' }, // list users for my company
    { permissionType: 'user:update', scope: 'self' }, // update my own user
    { permissionType: 'game:list', scope: 'downline' }, // list games for my company
    { permissionType: 'widget:list', scope: 'downline' }, // list widgets for my company
    { permissionType: 'workflow:list', scope: 'company' }, // list workflows for my company
    { permissionType: 'quiz:list', scope: 'company' }, // list quizzes for my company
    { permissionType: 'aiChat:list', scope: 'self' }, // list ai chats for mysel
    { permissionType: 'app:list', scope: 'company' }, // list Connect apps for my company
    { permissionType: 'stats:list', scope: 'company' }, // list stats for my company
    { permissionType: 'account:add', scope: 'self' },
    { permissionType: 'account:save', scope: 'self' },
    { permissionType: 'dashboard:list', scope: 'company' }, // view all dashboards for my company
    { permissionType: 'dashboard:manage', scope: 'self' }, // view all dashboards for my company
    { permissionType: 'shorts:manage', scope: 'self' },
  ],
}
